import React, { Component } from "react";
import { Input, Row, Col, message, } from "antd";
import { Form, Panel, } from "@/nano";

import { updatePassword } from "./personalSetting.service";

export default class UpdatePassword extends Component {

  state = {
    loading: false,
    data: {},
  };

  formRef = React.createRef();

  constructor(props) {
    super(props)
    if (["view", "update", "create"].includes(props.type)) {
      if ("create" === this.props.type) {

      } else {
        this.state.data = {
          ...this.state.data,
          ...props.data,
        };
      }
    }
  };

  onCancel = () => {
    this.props.onCancel && this.props.onCancel();
  };

  onConfirm = () => {
    this.formRef.current.submit();
    this.props.onConfirm && this.props.onConfirm();
  };

  onSubmit = (values) => {
    if ("update" === this.props.type) {
      const passwordData = {
        ...values,
        userId: this.props.data.userId,
      };
      updatePassword(passwordData).then(res => {
        message.success(res.message);
        this.onCancel();
        let newPassword = res.data.password ? res.data.password : "";
        this.props.onAfterSubmit && this.props.onAfterSubmit(newPassword);
      });
    } else {
      // save(values).then(res => {
      //   message.success(res.message);
      //   this.onCancel();
      //   this.props.onAfterSubmit && this.props.onAfterSubmit()
      // }).catch(res => {});
    }
  };

  render() {
    return (
      <Panel>
        <Panel.Info>
          <Form
            ref={this.formRef}
            data={this.state.data}
            onFinish={this.onSubmit}
            disabled={"view" === this.props.type}
          >
            <Row>
                <Col span={24}>
                    <Form.Item
                    name="oldPassword"
                    label="原密码"
                    rules={[
                        {
                        required: true,
                        message: "请输入您的原密码",
                        },
                    ]}
                    >
                    <Input.Password placeholder="input old password" />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <Form.Item
                    name="newPassword"
                    label="新密码"
                    rules={[
                        {
                        required: true,
                        message: "请输入您的新密码",
                        },
                    ]}
                    >
                    <Input.Password placeholder="input new password" />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <Form.Item
                    name="newCheckPassword"
                    label="重复新密码"
                    rules={[
                        {
                        required: true,
                        message: "请再次输入您的新密码",
                        },
                    ]}
                    >
                    <Input.Password placeholder="input new password again" />
                    </Form.Item>
                </Col>
            </Row>

          </Form>
        </Panel.Info>

        <Panel.Footer>
          <Panel.Footer.ButtonBar
            actions={[
              {
                type: "cancel",
                onClick: this.onCancel,
                loading: this.state.loading,
              },
              {
                type: "confirm",
                onClick: this.onConfirm,
                loading: this.state.loading,
                visible: ["create", "update"].includes(this.props.type),
              },
            ]}
          />
        </Panel.Footer>

      </Panel>
    );
  };

};
